import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName } from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ModalDirective } from 'ngx-bootstrap/modal';

import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import { ValidationService } from '../../../services/validation-service/validation.service';
import * as moment from 'moment';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: 'basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ValidationFormsService]
})


export class BasicFormsComponent {


  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

  // Timepicker

  public isEnabled: boolean = true;

  public mfData?: object = {};
  public courts?;
  public paymentMethods?;
  public facilities?;
  isUpdate: boolean = false;
  dbFunction?: string;
  facilityId: string;
  facilityTimingId: string;
  dayName: string;
  startTime: string;
  endTime: string;
  startDate: string;
  endDate: string;
  status: string;
  public isLoading = false;
  public daysArray?: Array<{ nameEn: string }> = [];

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});

  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('dangerModal', { static: false }) public dangerModal: ModalDirective;

  public paddingStyle: Object = { 'padding-right': '20px' };


  constructor(
    private router: Router,
    private http: HttpClient,
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService,
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    private validationSrv: ValidationService,
    public toolService: ToolService,
  ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;
    this.facilityId = this.storageSrv.getFacilityId();

    if (this.router.getCurrentNavigation().extras.state?.createData == null) {
      this.isUpdate = true;
      this.dbFunction = 'updateOwnersTable';
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.facilityTimingId = this.mfData['id'];
      this.dayName = this.mfData['dayName'];
      this.startTime = this.mfData['startTime'] != null ? new Date("2022/01/01" + " " + this.mfData['startTime'].replace(/-/g, "/")) : this.mfData['startTime'];
      this.endTime = this.mfData['endTime'] != null ? new Date("2022/01/01" + " " + this.mfData['endTime'].replace(/-/g, "/")) : this.mfData['endTime'];
      this.startDate = this.mfData['startDate'] != null ? new Date(this.mfData['startDate'].replace(/-/g, "/")) : this.mfData['startDate'];
      this.endDate = this.mfData['endDate'] != null ? new Date(this.mfData['endDate'].replace(/-/g, "/")) : this.mfData['endDate'];
      this.status = this.mfData['status'];
    }
    else {
      this.facilityTimingId = '';
      this.dayName = '';
      this.startTime = '';
      this.endTime = '';
      this.status = '';
    }
    // this.loadActiveUsers();
    // this.loadActiveFacilities();
    // this.createForm();
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess()
      .then(async () => {
        this.isLoading = true;
        this.route.queryParams.subscribe(async params => {
          this.loadDays();
          await this.createForm();
        });
      });
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message: string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      dayName: [this.dayName, [Validators.required]],
      startTime: [this.startTime, [Validators.required]],
      endTime: [this.endTime, [Validators.required]],
      startDate: [this.startDate],
      endDate: [this.endDate],
      status: [this.status, [Validators.required]],
    }, {});
    this.isLoading = false;
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError) {
      this.delay(2000).then(any => {
        this.router.navigate(['../'], { relativeTo: this.route }).then(() => {
          //window.location.reload();
        });;
      });
    }
    else if (!this.isUpdate && this.isError == false) {
      this.delay(2000).then(any => {
        this.router.navigate(['../'], { relativeTo: this.route }).then(() => {
          //window.location.reload();
        });;
      });
    }
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  saveFacilityTiming = () => {
    var startTime = moment(this.simpleForm.controls['startTime'] ? this.f['startTime'].value : null).format("HH:mm");
    var endTime = moment(this.simpleForm.controls['endTime'] ? this.f['endTime'].value : null).format("HH:mm");
    let formattedStartDate = (moment(new Date(this.f['startDate'].value))).format('YYYY-MM-DD');
    let formattedEndDate = (moment(new Date(this.f['endDate'].value))).format('YYYY-MM-DD');
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        facilityTimingId: this.facilityTimingId,
        facilityId: this.facilityId,
        dayName: this.f['dayName'].value,
        startTime: startTime,
        endTime: endTime,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        status: this.f['status'].value
      }
      if (this.isUpdate) {
        this.localInterfaceSrv.updateFacilityTiming(fields)
          .then(async res => {
            resolve(res);
            this.showSuccess('Timing Updated');
          })
          .catch(err => {
            reject(err);
            this.toastr.error(err.description, "Error");
          })
          .finally(() => this.isLoading = false);
      }
      else {
        this.localInterfaceSrv.addFacilityTiming(fields)
          .then(async res => {
            resolve(res);
            this.showSuccess('Timing Added');
          })
          .catch(err => {
            reject(err);
            this.toastr.error(err.description, "Error");
          })
          .finally(() => this.isLoading = false);
      }
    });
  }

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
  }

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }


  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }
  deleteFacilityTiming = (facilityTimingId) => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        facilityTimingId: facilityTimingId
      };
      this.localInterfaceSrv.deleteFacilityTiming(facilityTimingId)
        .then(async res => {
          resolve(res);
          this.toastr.success("Timing Removed", "Success");
          this.dangerModal.hide();
          this.router.navigate(['../'], { relativeTo: this.route }).then(() => {
          });
          //window.location.reload()
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.description, "Error");
          this.dangerModal.hide();
        })
        .finally(() => this.isLoading = false);
    });
  }
  loadDays = () => {
    this.daysArray.push({
      nameEn: 'saturday'
    },
      {
        nameEn: 'sunday'
      },
      {
        nameEn: 'monday'
      },
      {
        nameEn: 'tuesday'
      },
      {
        nameEn: 'wednesday'
      },
      {
        nameEn: 'thursday'
      },
      {
        nameEn: 'friday'
      });
  }
}
